import { render, staticRenderFns } from "./ExchangeRateSetNew.vue?vue&type=template&id=8d946e5e"
import script from "./ExchangeRateSetNew.vue?vue&type=script&lang=js"
export * from "./ExchangeRateSetNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports